import React from 'react';

const Stat = ({ label, value, color = 'text-white' }) => (
  <div className="flex flex-col items-center border border-[#658d71] px-3 py-2 bg-[rgba(0,0,0,0.1)] flex-1 min-w-0">
    <span className={`text-lg font-black tabular-nums ${color}`}>{value}</span>
    <span className="text-[8px] uppercase tracking-widest text-[#658d71] font-bold mt-0.5">{label}</span>
  </div>
);

const HitSummaryBar = ({ hits, awayAbbr, homeAbbr }) => {
  const awayHits = hits.filter(h => h.isTop);
  const homeHits = hits.filter(h => !h.isTop);

  const count = (arr, event) => arr.filter(h => h.event === event).length;

  const stats = [
    { label: `${awayAbbr} Hits`, value: awayHits.length, color: 'text-[#a9c9b1]' },
    { label: `${homeAbbr} Hits`, value: homeHits.length, color: 'text-[#c4333e]' },
    { label: 'Home Runs', value: count(hits, 'Home Run'), color: 'text-[#c4333e]' },
    { label: 'Doubles', value: count(hits, 'Double'), color: 'text-[#d8ceb3]' },
    { label: 'Triples', value: count(hits, 'Triple'), color: 'text-[#d8ceb3]' },
    { label: 'Singles', value: count(hits, 'Single'), color: 'text-white' },
  ];

  return (
    <div className="flex gap-1.5 flex-wrap sm:flex-nowrap">
      {stats.map(s => <Stat key={s.label} {...s} />)}
    </div>
  );
};

export default HitSummaryBar;